import styled, { css } from 'styled-components';

import { colors } from 'utils/styles/theme';

interface WrapperProps {
  hoverBackgroundColor: string;
}

export const Wrapper = styled.button<WrapperProps>`
  width: 90px;
  height: 90px;
  text-align: center;

  display: block;

  border-radius: 50%;

  background-color: ${colors.black + '33'};
  user-select: none;

  transition: background-color 0.4s linear;
  ${({ hoverBackgroundColor }) =>
    hoverBackgroundColor &&
    css`
      &:hover {
        background-color: ${colors[hoverBackgroundColor] ??
        hoverBackgroundColor};
      }
    `}
`;
